exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#splitScreenFGAWarning #notifications{margin-top:25px;margin-bottom:20px}.emailChangeHeaderBox{text-align:left;border-bottom:1px solid #dbdbdb;padding-bottom:25px;margin-bottom:15px}.emailChangeHeaderBox #headerEmailCheckInfo{text-align:left}.emailChangeHeaderBox .headerEmailContainer{height:20px;margin-top:20px}.emailChangeHeaderBox .headerEmailContainer .emailTextWrap{float:left;max-width:82%;margin-right:3%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-weight:700}.emailChangeHeaderBox .headerEmailContainer .emailChangeLink{float:left;width:15%}.emailChangeHeaderBox hr{margin:25px auto 15px;height:0;width:100%;clear:both;border:none;border-top:2px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-guest-components/src/guest/emailHeader/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-guest-components/src/guest/emailHeader/styles.less
// module chunks = 1